import React from 'react';
import './Degree.css';
import TermList from '../TermList/TermList';
import Chevron from '../Chevron/Chevron';
import Spinner from '../Spinner/Spinner';

const Degree = ({
  id,
  name,
  abbreviation,
  concentration,
  terms,
  termsShown,
  handleDegreeClick,
  handleTermClick,
  organizationId,
  loading,
  organizationIndex,
  index
}) => (
  <div>
    <div className="Degree--container">
      <div 
        role="button"
        className="Degree--bar" 
        onClick={() => handleDegreeClick(index, organizationIndex)}
        tabIndex={0}
        aria-expanded={termsShown}
        aria-controls={`degree-content-${organizationIndex}-${index}`}
      >
        <div className="Degree--name">
          <span>{name}</span>
        </div>
        {loading && <Spinner />}
        {!loading && <Chevron status={termsShown ? 'open' : 'closed'} />}
      </div>
    </div>
    {termsShown && (
      <div id={`degree-content-${organizationIndex}-${index}`}>
        <TermList
          terms={terms}
          degreeIndex={index}
          organizationIndex={organizationIndex}
          handleTermClick={handleTermClick}
        />
      </div>
    )}
  </div>
);

export default Degree;
